import NavigationCard, { BaseImage } from '../../../navigation/NavigationCard';
import { InternalNavigation } from '../../../navigation/helper';
import React from 'react';
import { CustomListsNavigationCard, QueryTemplatesNavigationCard } from './CommonNavigationCards';
import {
  CAN_ADD_FINAL_RISK_OVERRIDE_REASON,
  CAN_READ_CUSTOM_LIST,
  CAN_READ_QUERY_TEMPLATE,
  CAN_READ_RISK_RULE,
} from '../../../auth/permissions';
import Has from '../../../auth/Has';
import { faScaleBalanced, faScaleUnbalancedFlip } from '@fortawesome/pro-duotone-svg-icons';

const Risk = () => {
  return (
    <>
      <Has anyPermissions={[CAN_READ_RISK_RULE, CAN_ADD_FINAL_RISK_OVERRIDE_REASON]}>
        <h1 className={'m-b-8'}>Risk Configuration</h1>
        <div style={{ display: 'flex', gap: '32px' }}>
          <Has allPermissions={CAN_READ_RISK_RULE}>
            <NavigationCard
              title={'Risk Rules'}
              description={"Define and edit Risk Rules used to calculate a Person's risk level."}
              to={InternalNavigation.risk}
              image={{
                base: BaseImage.base7,
                icon: faScaleBalanced,
              }}
            />
          </Has>
          <Has allPermissions={CAN_ADD_FINAL_RISK_OVERRIDE_REASON}>
            <NavigationCard
              title={'Risk Override Reasons'}
              description={'Predefine the reasons required for manually changing risk levels.'}
              to={InternalNavigation.riskOverrideReasons}
              image={{
                base: BaseImage.base7,
                icon: faScaleUnbalancedFlip,
              }}
            />
          </Has>
        </div>
      </Has>
      <Has anyPermissions={[CAN_READ_CUSTOM_LIST, CAN_READ_QUERY_TEMPLATE]}>
        <h1 className={'m-b-8 m-t-32'}>Risk Inputs</h1>
        <div style={{ display: 'flex', gap: '32px' }}>
          <QueryTemplatesNavigationCard base={BaseImage.base2} />
          <CustomListsNavigationCard />
        </div>
      </Has>
    </>
  );
};

export default Risk;
